import { Log, Level, Logger } from 'ng2-logger';
import { put, takeEvery, all } from 'redux-saga/effects';
import ApiClient from './alms-api';
import { CourseSubNavigateType } from '../models/pages/main-menu';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('MainMenu-Service');

export class MainMenuService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetMainMenuAsync() {
        return _apiClient
            .RequestAsync('GET', 'api/organization/mainmenu', null, '', true)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_main_menu_error_message'),
                        'topRight'
                    );
                    return responseData;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch((response: any) => {
                Notification.setNotification(
                    'error',
                    T.t('r_main_menu_error_message'),
                    'topRight'
                );
                return response;
            });
    }
    public async RequestGetMainMenuCourseTabAsync() {
        return _apiClient
            .RequestAsync('GET', 'api/organization/menupanelitems', null, '')
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_main_menu_course_tab_data_error_message'),
                        'topRight'
                    );
                }
                return responseData;
            })
            .then((result: any) => {
                return result.json();
            })
            .catch(response => {
                Notification.setNotification(
                    'error',
                    T.t('r_main_menu_course_tab_data_error_message'),
                    'topRight'
                );
                return response;
            });
    }

    public async RequestGetMainMenuCourseContentAsync(
        teacher: boolean,
        status: number,
        subNavigationParam: any
    ) {
        const params = {
            apiUrl: teacher
                ? 'api/course/teachercourses'
                : 'api/course/enrolledcourses',
            parameters: !teacher
                ? {
                      Take: 5,
                      Skip: 0,
                      ActiveStatus: status,
                      CourseDateFilter: subNavigationParam,
                      SearchCourseName: '',
                      IsCourseSubNavigation: true
                  }
                : {
                      status:
                          subNavigationParam ===
                          CourseSubNavigateType.teacherCourse.toString()
                              ? 1
                              : subNavigationParam ===
                                CourseSubNavigateType.archivedLessonsTeacher.toString()
                              ? 0
                              : 1,
                      Take: 5,
                      Skip: 0,
                      IsCourseSubNavigation: true
                  },
        };
        return _apiClient
            .RequestAsync('POST', params.apiUrl, params.parameters, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_main_menu_course_tab_content_error_message'),
                        'topRight'
                    );
                }
                return responseData;
            })
            .then((result: any) => {
                return result.json();
            })
            .catch(response => {
                Notification.setNotification(
                    'error',
                    T.t('r_main_menu_course_tab_content_error_message'),
                    'topRight'
                );
                return response;
            });
    }
}
